import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { Translation } from '../store/slices/translationsSlice';
import {
  ApproveTranslationRequest,
  ApproveTranslationResponse,
  DeclineTranslationRequest,
  DeclineTranslationResponse,
  DeactivateTranslationRequest,
  DeactivateTranslationResponse,
  ProposeTranslationEditRequest,
  ProposeTranslationEditResponse,
  CreateNewTranslationRecordRequest,
  CreateNewTranslationRecordResponse,
  FetchTranslationsRequest,
  FetchTranslationsResponse,
  UpdateTranslationRequest,
} from '../types/translationTypes';
import { postJSON } from '../utils/RequestUtils';

export interface GetTranslationRecordDetailsRequest {
  translationRecordId: string;
  language: string;
}

// Simulate network delay
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// Search translations with filters and pagination
export async function fetchTranslations(request: FetchTranslationsRequest = {}, headers: Record<string, string> = {}): Promise<FetchTranslationsResponse> {
  const response = await postJSON(API_ENDPOINTS.FETCH_TRANSLATIONS, request, headers);
  return response as FetchTranslationsResponse;
}

// Update a translation
export async function updateTranslation(_request: UpdateTranslationRequest): Promise<Translation> {
  await delay(500);

  // Update translation function
  return {} as Translation;
}

// Approve a translation
export async function approveTranslation(request: ApproveTranslationRequest): Promise<ApproveTranslationResponse> {
  return postJSON<ApproveTranslationResponse, ApproveTranslationRequest>(API_ENDPOINTS.APPROVE_TRANSLATION, request);
}

// Decline a translation
export async function declineTranslation(request: DeclineTranslationRequest): Promise<DeclineTranslationResponse> {
  return postJSON<DeclineTranslationResponse, DeclineTranslationRequest>(API_ENDPOINTS.DECLINE_TRANSLATION, request);
}

// Propose translation edit (real API call)
export async function proposeTranslationEdit(request: ProposeTranslationEditRequest): Promise<ProposeTranslationEditResponse> {
  return postJSON<ProposeTranslationEditResponse, ProposeTranslationEditRequest>(
    API_ENDPOINTS.PROPOSE_TRANSLATION_EDIT,
    request
  );
}

// Deactivate a translation (real API call)
export async function deactivateTranslation(request: DeactivateTranslationRequest): Promise<DeactivateTranslationResponse> {
  return postJSON<DeactivateTranslationResponse, DeactivateTranslationRequest>(API_ENDPOINTS.DEACTIVATE_TRANSLATION, request);
}

// Create a new translation record (real API call)
export async function createNewTranslationRecord(
  payload: CreateNewTranslationRecordRequest
): Promise<CreateNewTranslationRecordResponse> {
  return postJSON<CreateNewTranslationRecordResponse, CreateNewTranslationRecordRequest>(
    API_ENDPOINTS.CREATE_NEW_TRANSLATION,
    payload
  );
}

// Get translation record details (real API call)
export async function getTranslationRecordDetails(
  request: GetTranslationRecordDetailsRequest
): Promise<TranslationDetail> {
  return postJSON<TranslationDetail, GetTranslationRecordDetailsRequest>(
    API_ENDPOINTS.GET_TRANSLATION_RECORD_DETAILS,
    request
  );
}
